import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Autocomplete,
	Button,
	Card,
	CardContent,
	Grid,
	Typography,
	Box,
	Divider,
	Stack
} from "@mui/material";
import TextField from "@mui/material/TextField";
import floatParser from "../../../helpers/floatParser";
import {IGider, IGiderTip, IHesap, IKalem} from "../../../constants/types/logbook";
import {KrediKartiKomisyon} from "../../../constants/tenant";
import IconButton from "@mui/material/IconButton";
import {Delete, Undo, ReceiptLong, AddCircleOutline, ExpandMore} from "@mui/icons-material";

const Giderler = (
	{
		giderler,
		setGiderler,
		giderTipleri,
		hesaplar,
	}: {
		giderler: IKalem<IGider>,
		setGiderler: any,
		giderTipleri: IGiderTip[],
		hesaplar: IHesap[],
	}) => {
	return (
		<Accordion
			elevation={0}
			sx={{
				backgroundColor: 'background.paper',
				borderRadius: '16px !important',
				border: '1px solid rgba(0,0,0,0.05)',
				mb: 1,
				overflow: 'hidden',
				'&:before': { display: 'none' }
			}}
		>
			<AccordionSummary expandIcon={<ExpandMore />}>
				<Stack direction="row" spacing={1.5} alignItems="center">
					<ReceiptLong color="primary" />
					<Typography variant="h6" fontWeight={800} sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>
						Giderler
					</Typography>
					<Typography variant="caption" sx={{ bgcolor: 'primary.main', color: 'white', px: 1, py: 0.2, borderRadius: 1, fontWeight: 700 }}>
						{giderler.data.length + giderler.eklenenListe.length} Kayıt
					</Typography>
				</Stack>
			</AccordionSummary>
			<AccordionDetails sx={{ bgcolor: '#fcfcfc', p: { xs: 1, md: 1.5 } }}>
				<Grid container spacing={1}>
					{
						giderler.data.map((gider, giderIndex) => {
								const giderTip = giderTipleri.find(sabit => sabit.id === gider.tip);
								const guncellenmis = giderler.guncellenecekIdListe.includes(gider.id ?? -1);
								const silinmis = giderler.silinecekIdListe.includes(gider.id ?? -1);
								if (guncellenmis) gider = giderler.guncellenecekListe[gider.id ?? 0];
								return (
									<Grid item xs={12} key={"gider-" + giderIndex}>
										<Card
											elevation={0}
											sx={{
												border: '1px solid',
												borderColor: guncellenmis ? 'info.light' : silinmis ? 'error.light' : 'rgba(0,0,0,0.08)',
												backgroundColor: guncellenmis ? 'info.light' : silinmis ? '#fff5f5' : '#fff',
												borderRadius: '12px',
												transition: 'all 0.2s'
											}}
										>
											<CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
												<Grid container spacing={1} alignItems="center">
													<Grid item xs={12} sm={4}>
														<Autocomplete
															size={"small"}
															disablePortal
															disabled={giderTip?.id === KrediKartiKomisyon || silinmis}
															options={giderTipleri.map(sabit => sabit.id)}
															getOptionLabel={option => giderTipleri.find(sabit => sabit.id === option)?.tip ?? ""}
															disableClearable
															renderInput={(params) => <TextField {...params} label="Gider Tipi"/>}
															value={gider.tip}
															onChange={(_, value) => {
																const guncel = {...gider};
																guncel.tip = value;
																setGiderler({
																	...giderler,
																	guncellenecekIdListe: [...(guncellenmis ? giderler.guncellenecekIdListe : [...giderler.guncellenecekIdListe, gider.id ?? 0])],
																	guncellenecekListe: {...giderler.guncellenecekListe, [gider.id ?? 0]: guncel}
																})
															}}
														/>
													</Grid>
													<Grid item xs={12} sm={4}>
														<Autocomplete
															size={"small"}
															disablePortal
															disabled={giderTip?.id === KrediKartiKomisyon || silinmis}
															options={hesaplar.map(sabit => sabit.id)}
															getOptionLabel={option => hesaplar.find(sabit => sabit.id === option)?.hesapAdi ?? ""}
															disableClearable
															renderInput={(params) => <TextField {...params} label="Kaynak"/>}
															value={gider.kaynak}
															onChange={(_, value) => {
																const guncel = {...gider};
																guncel.kaynak = value;
																setGiderler({
																	...giderler,
																	guncellenecekIdListe: [...(guncellenmis ? giderler.guncellenecekIdListe : [...giderler.guncellenecekIdListe, gider.id ?? 0])],
																	guncellenecekListe: {...giderler.guncellenecekListe, [gider.id ?? 0]: guncel}
																})
															}}
														/>
													</Grid>
													<Grid item xs={12} sm={4}>
														<TextField
															size={"small"}
															fullWidth
															disabled={giderTip?.id === KrediKartiKomisyon || silinmis}
															type={"number"}
															label={"Tutar"}
															InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 1, fontWeight: 700 }}>₺</Typography> }}
															value={"" + gider.miktar}
															onChange={(event) => {
																const guncel = {...gider};
																guncel.miktar = floatParser(event.target.value);
																setGiderler({
																	...giderler,
																	guncellenecekIdListe: [...(guncellenmis ? giderler.guncellenecekIdListe : [...giderler.guncellenecekIdListe, gider.id ?? 0])],
																	guncellenecekListe: {...giderler.guncellenecekListe, [gider.id ?? 0]: guncel}
																})
															}}
														/>
													</Grid>

													{giderTip?.id !== KrediKartiKomisyon && <>
														<Grid item xs={12} sm={10}>
															<TextField
																size={"small"}
																disabled={silinmis}
																fullWidth
																type={"text"}
																label={"Açıklama"}
																value={gider.aciklama}
																onChange={(event) => {
																		const guncel = {...gider};
																		guncel.aciklama = event.target.value;
																		setGiderler({
																			...giderler,
																			guncellenecekIdListe: [...(guncellenmis ? giderler.guncellenecekIdListe : [...giderler.guncellenecekIdListe, gider.id ?? 0])],
																			guncellenecekListe: {...giderler.guncellenecekListe, [gider.id ?? 0]: guncel}
																		})
																	}}
															/>
														</Grid>
														<Grid item xs={12} sm={2}>
															<Stack direction="row" spacing={1} justifyContent={{ xs: 'center', sm: 'flex-end' }}>
																<IconButton
																	size="small"
																	disabled={silinmis}
																	onClick={() => {
																		setGiderler({
																			...giderler,
																			silinecekIdListe: [...giderler.silinecekIdListe, gider.id ?? 0],
																		})
																	}}
																	color={"error"}
																	sx={{ bgcolor: 'error.light', '&:hover': { bgcolor: '#ffcdd2' } }}
																>
																	<Delete fontSize="small" />
																</IconButton>
																<IconButton
																	size="small"
																	disabled={!guncellenmis && !silinmis}
																	onClick={() => {
																		if (guncellenmis) {
																			setGiderler({
																				...giderler,
																				guncellenecekIdListe: giderler.guncellenecekIdListe.filter(id => id !== gider.id),
																			})
																		} else {
																			setGiderler({
																				...giderler,
																				silinecekIdListe: giderler.silinecekIdListe.filter(id => id !== gider.id),
																			})
																		}
																	}}
																	color={"info"}
																	sx={{ bgcolor: 'info.light', '&:hover': { bgcolor: '#b3e5fc' } }}
																>
																	<Undo fontSize="small" />
																</IconButton>
															</Stack>
														</Grid>
													</>}
												</Grid>
											</CardContent>
										</Card>
									</Grid>
								)
						}
					)
				}
				{
					giderler.eklenenListe.map((gider, giderIndex) => {
						const giderTip = giderTipleri.find(sabit => sabit.id === gider.tip);
						return (
							<Grid item xs={12} key={"gider_ekle-" + giderIndex}>
								<Card
									elevation={0}
									sx={{
										border: '2px dashed',
										borderColor: 'success.main',
										backgroundColor: '#f1fff1',
										borderRadius: '12px'
									}}>
									<CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
										<Grid container spacing={1} alignItems="center">
											<Grid item xs={12} sm={4}>
												<Autocomplete
													size={"small"}
													disablePortal
													disabled={giderTip?.id === KrediKartiKomisyon}
													options={giderTipleri.map(sabit => sabit.id).filter(q => q !== KrediKartiKomisyon)}
													getOptionLabel={option => giderTipleri.find(sabit => sabit.id === option)?.tip ?? ""}
													disableClearable
													renderInput={(params) => <TextField {...params} label="Gider Tipi"/>}
													value={gider.tip}
													onChange={(_, value) => {
														setGiderler(
															{
																...giderler,
																eklenenListe: giderler.eklenenListe.map((g, index) => {
																	if (index === giderIndex) return {...g, tip: value};
																	return g;
																})
															})
													}}
												/>
											</Grid>
											<Grid item xs={12} sm={4}>
												<Autocomplete
													size={"small"}
													disablePortal
													disabled={giderTip?.id === KrediKartiKomisyon}
													options={hesaplar.map(sabit => sabit.id)}
													getOptionLabel={option => hesaplar.find(sabit => sabit.id === option)?.hesapAdi ?? ""}
													disableClearable
													renderInput={(params) => <TextField {...params} label="Kaynak"/>}
													value={gider.kaynak}
													onChange={(_event, value) => {
														setGiderler(
															{
																...giderler,
																eklenenListe: giderler.eklenenListe.map((g, index) => {
																	if (index === giderIndex) return {...g, kaynak: value};
																	return g;
																})
															})
													}}
												/>
											</Grid>
											<Grid item xs={12} sm={4}>
												<TextField
													size={"small"}
													fullWidth
													disabled={giderTip?.id === KrediKartiKomisyon}
													type={"number"}
													label={"Tutar"}
													InputProps={{ endAdornment: <Typography variant="caption" sx={{ ml: 1, fontWeight: 700 }}>₺</Typography> }}
													value={"" + gider.miktar}
													onChange={(event) => {
														setGiderler(
															{
																...giderler,
																eklenenListe: giderler.eklenenListe.map((g, index) => {
																	if (index === giderIndex) return {
																		...g,
																		miktar: floatParser(event.target.value)
																	};
																	return g;
																})
															})
													}}
												/>
											</Grid>

											{giderTip?.id !== KrediKartiKomisyon && <>
												<Grid item xs={12} sm={11}>
													<TextField
														size={"small"}
														fullWidth
														type={"text"}
														label={"Açıklama"}
														value={gider.aciklama}
														onChange={(event) => {
															setGiderler(
																{
																	...giderler,
																	eklenenListe: giderler.eklenenListe.map((g, index) => {
																		if (index === giderIndex) return {
																			...g,
																			aciklama: event.target.value
																		};
																		return g;
																	})
																})
														}}
													/>
												</Grid>
												<Grid item xs={12} sm={1} sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' } }}>
													<IconButton
														size="small"
														onClick={() => {
															setGiderler(
																{
																	...giderler,
																	eklenenListe: giderler.eklenenListe.filter((_, index) => index !== giderIndex)
																}
															)
														}}
														color={"error"}
														sx={{ bgcolor: 'error.light', '&:hover': { bgcolor: '#ffcdd2' } }}
													>
														<Delete fontSize="small" />
													</IconButton>
												</Grid>
											</>}
										</Grid>
									</CardContent>
								</Card>
							</Grid>
						)
					})
				}
				<Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
					<Button
						variant="outlined"
						startIcon={<AddCircleOutline />}
						onClick={() => {
							setGiderler({
								...giderler,
								eklenenListe:
									[
										...giderler.eklenenListe,
										{
											aciklama: "",
											miktar: 0,
											tip: 0,
											kaynak: 0,
										}]
							})
						}}
						sx={{ 
							borderRadius: '10px', 
							textTransform: 'none', 
							fontWeight: 700,
							px: 4,
							borderWidth: '2px',
							'&:hover': { borderWidth: '2px' }
						}}
					>
						Yeni Gider Ekle
					</Button>
				</Grid>
			</Grid>
		</AccordionDetails>
	</Accordion>
	);
}

export default Giderler;